/**
 * Inline footer signature after © / shop: `.` + <wbr> + XOR ` This site is ONDISPLAY.` (period after ONDISPLAY).
 * Inner uses display:contents so punctuation + wbr + copy + link align like plain inline text.
 * Hover trigger ≥2s → reveal (soft). Any click on trigger (including shop name <a>) → blast;
 * first shop link click is prevented until revealed, then the link works normally.
 * Skipped when <html data-odx-signature-vendor> or odx-test-lab-page.
 */
(function () {
  'use strict';

  if (document.documentElement.hasAttribute('data-odx-signature-vendor')) return;
  if (document.body && document.body.classList.contains('odx-test-lab-page')) return;
  if (document.documentElement.hasAttribute('data-odx-signature-fb-init')) return;
  document.documentElement.setAttribute('data-odx-signature-fb-init', '');

  var K = 217;
  var B = [
    249, 141, 177, 176, 170, 249, 170, 176, 173, 188, 249, 176, 170, 249, 150, 151, 157, 144, 138, 137, 149, 152, 128, 247,
  ];
  var HOVER_MS = 5000;
  var MARK = 'ONDISPLAY';

  function x(a, k) {
    var o = '';
    for (var i = 0; i < a.length; i++) o += String.fromCharCode(a[i] ^ k);
    return o;
  }

  function mount() {
    var trigger = document.querySelector('[data-odx-site-sig-trigger]');
    if (!trigger || !trigger.parentNode) return;

    var full = x(B, K);
    var mi = full.indexOf(MARK);
    if (mi < 0) return;
    var preText = full.slice(0, mi);
    var postText = full.slice(mi + MARK.length);

    var revealEl = document.createElement('span');
    revealEl.className = 'odx-site-sig-reveal';
    revealEl.setAttribute('data-odx-site-sig-reveal', '');
    revealEl.setAttribute('aria-hidden', 'true');

    var inner = document.createElement('span');
    inner.className = 'odx-site-sig-reveal__inner';

    var lead = document.createElement('span');
    lead.className = 'odx-site-sig-reveal__lead';
    lead.textContent = '.';

    var brk = document.createElement('wbr');

    var pre = document.createElement('span');
    pre.className = 'odx-site-sig-reveal__pre';
    pre.textContent = preText;

    var mk = document.createElement('a');
    mk.className = 'odx-site-sig-reveal__mark';
    mk.href = 'https://ondisplay.ca';
    mk.target = '_blank';
    mk.rel = 'noopener noreferrer';
    mk.setAttribute('aria-label', 'ONDISPLAY');
    mk.textContent = MARK;

    inner.appendChild(lead);
    inner.appendChild(brk);
    inner.appendChild(pre);
    inner.appendChild(mk);
    if (postText) {
      var tail = document.createElement('span');
      tail.className = 'odx-site-sig-reveal__tail';
      tail.textContent = postText;
      inner.appendChild(tail);
    }
    revealEl.appendChild(inner);

    trigger.parentNode.insertBefore(revealEl, trigger.nextSibling);

    var shopA = trigger.querySelector('a[href]');
    var revealed = false;
    var hoverTimer = null;

    function clearHover() {
      if (hoverTimer) {
        clearTimeout(hoverTimer);
        hoverTimer = null;
      }
    }

    function activate(mode) {
      if (revealed) return;
      revealed = true;
      clearHover();
      revealEl.setAttribute('aria-hidden', 'false');
      revealEl.classList.add('odx-site-sig-reveal--show');
      if (mode === 'blast') {
        var reduce =
          window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) {
          return;
        }
        revealEl.classList.add('odx-site-sig-reveal--blast');
        function onBlastEnd(e) {
          if (e.animationName !== 'odx-site-sig-blast') return;
          revealEl.removeEventListener('animationend', onBlastEnd);
          revealEl.classList.remove('odx-site-sig-reveal--blast');
        }
        revealEl.addEventListener('animationend', onBlastEnd);
      }
    }

    trigger.addEventListener('mouseenter', function () {
      if (revealed) return;
      clearHover();
      hoverTimer = setTimeout(function () {
        hoverTimer = null;
        activate('hover');
      }, HOVER_MS);
    });

    trigger.addEventListener('mouseleave', clearHover);

    if (shopA) {
      shopA.addEventListener(
        'click',
        function (e) {
          if (revealed) return;
          e.preventDefault();
          activate('blast');
        },
        true,
      );
      shopA.addEventListener('keydown', function (e) {
        if (revealed) return;
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        activate('blast');
      });
    }

    trigger.addEventListener('click', function (e) {
      if (revealed) return;
      if (shopA && shopA.contains(e.target)) return;
      e.preventDefault();
      activate('blast');
    });

    trigger.addEventListener('keydown', function (e) {
      if (revealed) return;
      if (shopA && shopA.contains(e.target)) return;
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      activate('blast');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }
})();
